import * as Auth from '../utils/auth';

const Menu = [
  { header: 'Xin chào' },
  {
    title: 'Bảng điều khiển',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    url: '/dashboard',
    roles: ['Statistics'],
    isAccess: true
  },
  {
    title: 'Khách hàng',
    group: 'apps',
    icon: 'person',
    name: 'Account',
    url: '/account',
    roles: ['GetAccount'],
    isAccess: true
  },
  {
    title: 'Xe',
    group: 'apps',
    name: 'Vehicle',
    icon: 'motorcycle',
    url: '/vehicle',
    roles: ['GetVehicle'],
    isAccess: true
  },
  {
    title: 'Thiết bị',
    group: 'apps',
    name: 'Device',
    icon: 'dock',
    url: '/device',
    roles: ['GetDevice'],
    isAccess: true
  },
  {
    title: 'Gửi Thông báo',
    group: 'apps',
    name: 'Notification',
    icon: 'notifications',
    url: '/notification',
    roles: ['Notification'],
    isAccess: true,
  },
  {
    title: 'Ngôn ngữ',
    group: 'apps',
    name: 'Language',
    icon: 'language',
    url: '/language',
    roles: ['Language'],
    isAccess: false,
  },
  {
    title: 'Phân quyền',
    group: 'apps',
    name: 'GroupRole',
    icon: 'supervisor_account',
    url: '/grouprole',
    roles: ['GroupRole'],
    isAccess: false
  },
];

// reorder menu
Menu.forEach(item => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu.js